import { render } from "./ProductTable.vue?vue&type=template&id=2b9e2af8&scoped=true"
import script from "./ProductTable.vue?vue&type=script&lang=js"
export * from "./ProductTable.vue?vue&type=script&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=2b9e2af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9e2af8"]])

export default __exports__